// extracted by mini-css-extract-plugin
export default {"content":"Button_content__RQLuC"};